"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaypalPaymentType = void 0;
const path = require('path');
const LABEL = 'Paypal payment type';
class PaypalPaymentType {
    constructor() {
        this.indexname = 'paypal';
        this.label = LABEL;
        this.vueJsComponent = 'paypal-payment-type';
        this.configurationComponentAssets = [
            {
                id: 'paypal-payment-type_script',
                tag: 'script',
                attributes: {
                    type: 'text/javascript'
                },
                content: path.join(__dirname, '../../dist/paypal-settings.js')
            },
            {
                id: 'paypal-payment-type_style',
                tag: 'style',
                content: path.join(__dirname, '../../dist/css/app.css')
            },
            {
                id: 'material-icons',
                tag: 'link',
                attributes: {
                    href: 'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900|Material+Icons',
                    rel: 'stylesheet'
                }
            }
        ];
        this.configurationComponentTag = '<paypal-settings></paypal-settings>';
        this.supportPartialPayment = true;
    }
    static getLabel() {
        return LABEL;
    }
}
exports.PaypalPaymentType = PaypalPaymentType;
//# sourceMappingURL=paypal-payment-type-config.js.map